import React from 'react';

/* eslint-disable react/no-danger */
export function svgDisplay(image, style) {
  return (
    <div
      className="icon"
      dangerouslySetInnerHTML={{ __html: image }}
      style={style}
    />
  );
}

export default svgDisplay;



// WEBPACK FOOTER //
// ./src/components/SvgInline/SvgInline.js